import React, { useState, useEffect, useRef } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from 'react-router-dom';
import PaidPaymentDetailModel from './PaidPaymentDetailModel';

const RunPayrollPaidModel = ({ toggleOffCanvas, setIsOffCanvasOpen, isOffCanvasOpen, paidPayment, setPaidPayment }) => {
     const [isOpen, setIsOpen] = useState(false);
    const [isOffCanvasOpenAction, setIsOffCanvasOpenAction] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    const toggleCollapse = () => {
        setIsOpen(!isOpen);
    };
    const toggleOffCanvasAction = () => {
        setSelectedItem(null);
    };

    const sidebarRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setIsOffCanvasOpen(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [setIsOffCanvasOpen]);
    return (

        <>
            <PaidPaymentDetailModel
                isOffCanvasOpenAction={selectedItem !== null}
                item={selectedItem}
                staff={paidPayment}
                setIsOffCanvasOpenAction={toggleOffCanvasAction}
                toggleOffCanvasAction={toggleOffCanvasAction}
                setPaidPayment={setPaidPayment}
            />
            <div
                // ref={sidebarRef}
                className={`fixed top-[56px] right-0 h-screen sm:w-[400px] w-full  z-[99] shadow-cs bg-white payroll-sidebar shadow-lg transform transition-transform duration-300 ${isOffCanvasOpen ? "translate-x-0" : "translate-x-full"
                    }`}
            >
                <div className="relative w-full h-full">
                    <div className="flex justify-between items-center border-gray-200 p-4 border-b">
                        <h2 className="font-semibold text-[#000] text-[18px]">{paidPayment?.name}</h2>
                        <button
                            className="text-[black]"
                            onClick={setIsOffCanvasOpen}
                        >
                            <CloseIcon />
                        </button>
                    </div>
                    <div className="relative z-[1] bg-red mb-[10px] p-[10px] pb-[20px] w-full max-w-md h-[82%] overflow-y-scroll">
                        <div className="flex justify-between items-center bg-[#e5e7eb96] mb-[10px] p-[10px] pr-[42px] w-full">
                            <p className="font-normal text-muted-foreground text-sm">Paid </p>
                            <p className="font-normal text-muted-foreground text-sm">₹ 0.000</p>
                        </div>

                        {
                            paidPayment?.staffDetails?.SalaryDetails[0]?.PaymentHistory?.length === 0 && <p className='font-light text-center text-muted-foreground text-sm'>No Payment History Found</p>
                        }

                        {
                            paidPayment?.staffDetails?.SalaryDetails[0]?.PaymentHistory?.map((item, index) => (
                                <Link onClick={() => {
                                    setSelectedItem(item)
                                }} className='flex justify-between items-center hover:bg-[#e5e7eb96] px-[10px] py-[10px] pb-[10px] border-b transition-all'>
                                    <div>
                                        <p className='font-light text-muted-foreground text-sm'>{new Date(item?.date).toDateString()}</p>
                                        <p className='font-light text-[12px] text-muted-foreground'>{item?.type}</p>
                                    </div>
                                    <div className='flex gap-[10px]'>
                                        <p className='font-light text-muted-foreground text-sm'>₹{item?.amount}</p>
                                        <KeyboardArrowRightIcon className='bg-[#e5e7eb96] p-[3px] rounded-[40px]' />
                                    </div>
                                </Link>
                            ))
                        }



                    </div>
                </div>

            </div>
        </>
    )
}

export default RunPayrollPaidModel